// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1vlEm","header":"ReportDetails_header__2reyb","title":"ReportDetails_title__2TiIk","left":"ReportDetails_left__1xZxi"};